import { CommerceHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/CommerceHubFaqs';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import Products from 'merchandise-lib/constants/Product';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import ProductInfoContainer from '../components/ProductInfoContainer';
import BannerSection from '../components/banners/BannerSection';
import { IntegrationsSection } from '../v2/containers/IntegrationsSection';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import ValuePropsSection from '../components/common/ValuePropsSection';
import { CreditsCallout } from '../components/common/credits-callout/CreditsCallout';
import FallbackErrorBanner from '../components/common/loading/FallbackErrorBanner';
import ProductFeatureTable from '../components/feature-table/ProductFeatureTable';
import HeaderLayout from '../components/layout/HeaderLayout';
import { ProductCardContainer } from '../components/merch-card/card-containers/ProductCardContainer';
import { COMMERCE_HUB_PAGE_CONTENT, COMMERCE_PAGE } from '../constants/ErrorBoundaryNames';
import { DEFAULT } from '../constants/ErrorCauses';
import { NavItemEnum } from '../constants/routing/NavItems';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { ERROR_SEVERITY } from '../v2/components/error-boundary/ErrorSeverity';
import withErrorBoundary from '../v2/components/error-boundary/withErrorBoundary';
import { SCREENS } from '../v2/constants/tracking/Screens';
import { MERCH_CARD, TRACKING_SOURCES } from '../v2/constants/tracking/TrackingSources';
import { trackClickedLink, trackFaqInteraction, trackPageView } from '../v2/utils/tracking/trackingEventUtils';
import ErrorPage from './ErrorPage';
import MissingInfoFallbackPage from './MissingInfoFallbackPage';
import { FeatureTable } from 'feature-monetization';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { getPrimaryTracker } from 'usage-tracker-container';
import PaymentsProcessorsSectionWrapper from '../v2/components/commerce-hub/PaymentsProcessorsSectionWrapper';
import ViewPricingLink from '../v2/components/commerce-hub/ViewPricingLink';
import { ErrorBoundary } from '../v2/components/error-boundary/ErrorBoundary';
import PhoneSupportFooter from '../v2/components/phone-support/PhoneSupportFooter';
import { useIsInAppAuth } from '../v2/hooks/user/useUserInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommerceHubPage = () => {
  const isInAppAuth = useIsInAppAuth();
  const navItem = NavItemEnum.COMMERCE;
  const navMarkerName = `${navItem.toUpperCase()}_PAGE`;
  const screen = SCREENS.COMMERCE;
  useDocumentTitle(navItem);
  useEffect(() => {
    trackPageView({
      screen: navItem
    });
  }, [navItem]);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(MissingInfoFallbackPage, {
      navItem: navItem
    }),
    errorBoundaryName: COMMERCE_HUB_PAGE_CONTENT,
    severity: ERROR_SEVERITY.HIGH,
    metricsOptions: {
      route: navItem
    },
    children: /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName
      }), /*#__PURE__*/_jsx(HeaderLayout, {
        selectedNavItem: navItem,
        children: /*#__PURE__*/_jsxs(ProductInfoContainer, {
          children: [/*#__PURE__*/_jsx(BannerSection, {
            screen: screen
          }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PPUIPageHeader, {
            children: [/*#__PURE__*/_jsx(ProductPageTitle, {
              productLine: COMMERCE
            }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
              productLine: COMMERCE
            }), /*#__PURE__*/_jsx(ViewPricingLink, {})]
          }), /*#__PURE__*/_jsx(ProductCardContainer, {
            screen: screen,
            productsToShow: [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE],
            trackingSource: MERCH_CARD
          }), /*#__PURE__*/_jsx(PageSection, {
            children: /*#__PURE__*/_jsx(CreditsCallout, {
              navItem: 'commerce'
            })
          }), /*#__PURE__*/_jsx(PageSection, {
            children: isInAppAuth ? /*#__PURE__*/_jsx(CardWrapper, {
              borderRadius: "300",
              borderWidth: "100",
              blockSize: "100%",
              marginBlock: "0",
              children: /*#__PURE__*/_jsx(CardSection, {
                children: /*#__PURE__*/_jsx(FeatureTable, {
                  skuCategoryName: "COMMERCE_PRODUCTS",
                  productApiNames: [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE],
                  usageTracker: getPrimaryTracker()
                })
              })
            }) : /*#__PURE__*/_jsx(ProductFeatureTable, {
              productLine: 'COMMERCE',
              highlightedProducts: [Products.COMMERCE_HUB_PROFESSIONAL, Products.COMMERCE_HUB_ENTERPRISE],
              screen: screen
            }, `commerce`)
          }), /*#__PURE__*/_jsx(PaymentsProcessorsSectionWrapper, {}), /*#__PURE__*/_jsx(IntegrationsSection, {}), /*#__PURE__*/_jsx(PageSection, {
            children: /*#__PURE__*/_jsx(CommerceHubFaqs, {
              onLinkClick: props => trackClickedLink(Object.assign({}, props, {
                trackingSource: TRACKING_SOURCES.FAQ
              })),
              onFaqInteraction: trackFaqInteraction
            })
          }), /*#__PURE__*/_jsx(ValuePropsSection, {}), /*#__PURE__*/_jsx(PhoneSupportFooter, {
            phoneSourceId: TRACKING_SOURCES.COMMERCE_FOOTER,
            screen: SCREENS.COMMERCE,
            apiName: Products.COMMERCE_HUB_PROFESSIONAL
          })]
        })
      })]
    })
  });
};
export default withErrorBoundary(CommerceHubPage, {
  FallbackComponent: () => /*#__PURE__*/_jsx(ErrorPage, {
    errorCause: DEFAULT
  }),
  errorBoundaryName: COMMERCE_PAGE,
  severity: ERROR_SEVERITY.HIGH
});